const tierColors = {
  'Casual Visitor': '#FFCA3E',
  'Rising Star': '#FFCA3E',
  'Wager Dabbler': '#86D226',
  'Bet Master': '#933EFF',
  'Pro Gambler': '#425AD8',
  'Casino Rockstar': '#FF833E',
  'High Roller': '#F00',
  'Prodigy Gambler': '#FF00C7',
  'Bets Conqueror': '#00FFB2',
  'Wager Phenom': '#00F0FF',
  'Wager Titan': '#F0FF36',
  'Risk Sensei': '#4636FF',
  'Payout Guru': '#00FF57',
  'Immaculate Gambler': '#000000',
}

const sizeStyles = {
  small: 'w-40 h-20 text-3xs',
  medium: 'w-60 h-26 text-xs',
  large: 'w-80 h-30 text-sm',
}

const EliteSeatChip = ({
  text,
  tier,
  size = 'small',
}: {
  text: string
  tier: string
  size?: 'small' | 'medium' | 'large'
}) => {
  if (!text || !tier) return null

  const backGround = tierColors[tier] || '#000'
  const sizeClass = sizeStyles[size] || sizeStyles.small

  return (
    <div
      className={`pb-1 text-white font-extrabold flex-shrink-0 rounded-b-3 flex items-end justify-center ${sizeClass}`}
      style={{ background: `linear-gradient(180deg, rgba(9, 50, 25, 0.00) 0%, ${backGround} 100%)` }}
    >
      {text}
    </div>
  )
}

export default EliteSeatChip
